<template>
	<b-modal id="cityModal" ref="cityModal" body-class="p-0" hide-footer hide-header centered>
		<h3 class="text-center">Необходимо указать город</h3>
		<div class="form-group mb-0">
			<label class="control-label" for="modal-city">Город</label>
			<vue-bootstrap-typeahead
					id="modal-city"
					name="modal-city"
					:data="cityList"
					v-model="modelCity"
					:serializer="s => s"
			/>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary btn-block" data-dismiss="modal">Закрыть</button>
		</div>
	</b-modal>
</template>

<script>
	import cityMixin from '../../mixins/cityMixin';
	import {mapGetters} from 'vuex';
	import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

	export default {
		name: "ProfileModalCity",
		components: {VueBootstrapTypeahead},
		data() {
			return {
				cityList: [],
			}
		},
		methods: {
			loadCityList(query) {
				this.CITY_LIST(query).then(res => {
					const resultArray = [];
					for (let key in res.body) {
						resultArray.push(res.body[key])
					}

					this.cityList = resultArray;
				});
			},
		},
		computed: {
			...mapGetters({
				dataUser: "profile/dataUser"
			})
		},
		mixins: [cityMixin],
		watch: {
			'modelCity': _.debounce(function (addr) {
				this.loadCityList(addr)
			}, 500),
		}
	}
</script>

<style scoped>

</style>
